var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$route.name + '-page'},[((!_vm.isPage('bzsm'))&&(!_vm.isPage('lxwm')))?_c('Header',{ref:"pchd"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content_template"},[(_vm.RouterShow)?_c('router-view'):_vm._e()],1),_vm._v(" "),((!_vm.isPage('bzsm'))&&(!_vm.isPage('lxwm')))?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8d36624","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/todoCenter/default/workflow/layout/index.vue
// module id = M36u
// module chunks = 16